<template>
    <div class="activeList ">
      <Search @typesChange="typesChange"></Search>
      <!-- 滑动区域 -->
      <div class="scroll">
        <van-list  v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" ref="fuckList" :immediate-check="false">
          <template v-for="item in list">
            <Card :data="item" :menuId="menuId"></Card>
          </template>
        </van-list>
      </div>

      <!-- 分页数据计算 -->
      <div class="loaded" v-if="!loading">已加载 {{list.length}}/{{total}}</div>

      <!-- 定位 -->
      <div :class="hasAddAuth ? 'orientation-bottom' : 'orientation-bottom-1'">
        <!-- 主页 -->
        <div class="homePage" @click="$router.push('/')">
          <img :src="require('@/assets/img/homePage.png')" class="homePageImg" alt="">
        </div>
        <!-- 添加 -->
        <div class="add" @click="toApply" v-if="hasAddAuth">
          <img :src="require('@/assets/img/add.png')" class="addImg" alt="">
        </div>
      </div>
    </div>
</template>
<script>
  import Search from './component/activeSearch.vue'
  import Card from './component/activeListCard.vue'
  import apiActive from '@/api/active'
  import Page from "../../globalComponent/Page/index.vue";
  import $ from "jquery";

    export default{
        data(){
            return {
              loading:false,
              finished:false,
              total:0,
              list:[],
              userId:'',
              campType:'',
              campName:'',
              pageNo:1,
              pageSize:10,
              lastPage : false,
              id:'',
              //菜单ID
              menuId : '',
              hasAddAuth : true, //是否有新增的权限
            }
        },
        components:{
          Page,
          Search,
          Card
        },
        watch:{
          '$route' (to, from) {
            if(from.name == 'Index'){
              this.campType = ''
              this.campName = ''
              this.list = []
              this.pageNo = 1
              this.loading = false
              this.finished = false
              this.getList();
            }
          }
        },
        methods:{
          toApply(){
              this.$router.push('/active/apply')
          },
          typesChange(data){
              this.campType = data.campType
              this.campName = data.campName
              this.list = []
              this.pageNo = 1
              this.loading = false
              this.finished = false
              this.getList();
          },

          onLoad : function () {
            var that = this;
            that.getList();
          },

          getList(){
            var that = this;
            var response = apiActive.campaignPage({
              salesId:that.$wxuserUtil.getUserId(),
              campType:that.campType,
              campName:that.campName,
              pageNo:that.pageNo,
              pageSize:that.pageSize
            });
            if(response.success){
              var pageList = response.data.list;
              that.list.push(...pageList);

              that.total = response.data.totalRow
              that.lastPage = response.data.lastPage;
              if(!that.lastPage){
                that.pageNo=that.pageNo+1
              }
            }else{
              that.$title(`获取活动列表失败,${response.msg}`);
            }

            if(that.lastPage){
              that.finished = true;
            }
            that.loading = false;
          }
        },
        created(){
        },
        mounted(){
          this.hasAddAuth = this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Created);
          this.getList();
          this.menuId = this.$route.query.menuId;
          $(".scroll").css({"max-height" : $("body").height()})
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../style/pageStyle/pageView-activeList.less";
  .add-active{
    position: fixed;
    right:10px;
    bottom:100px;
    z-index:2;
    img{
      width:50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/active/list.vue